/**
 * Showing element with css class or jquery methods fadeIn and slideIn
 *
 * @param element {HTMLElement} HTML Element from Document
 * @param elClass {string}      Class to control, default is show
 */
function showElement( element, elClass = 'show' ) {
	element.setAttribute( 'aria-expanded', 'true' );
// Get element to open from btn's data-open attribute
	const modal             = document.querySelector( element.dataset.open ),
	      type_of_animation = element.dataset.hasOwnProperty( 'function' ) ? element.dataset.function : null;

	if ( modal == undefined ) {
		return;
	}

	// If element to open has class modal, add class overflow to body
	// Overflow class is used in css to apply overflow hidden on body
	// to prevent scrolling while modal is openned
	if ( modal.classList.contains( 'modal' ) || modal.classList.contains( 'navbar__collapse' ) || modal.id == 'header' ) {
		document.body.classList.add( 'overflow' );
	}
	switch ( type_of_animation ) {
		case 'fade':
			$( modal ).fadeIn();
			break;
		case 'slide':
			$( modal ).slideDown();
			break;
		default:
			modal.classList.add( elClass );
	}
}

/**
 * Hiding element with css class or jquery methods fadeIn and slideIn
 *
 * @param element {Element} HTML Element from Document
 * @param elClass {string}      Class to control, default is show
 */
function HideElement( element, elClass = 'show' ) {
	element.setAttribute( 'aria-expanded', 'false' );
	// Get element to open from btn's data-open attribute
	const modal             = element.classList.contains( 'modal' ) ? element : document.querySelector( element.dataset.close ),
	      type_of_animation = element.dataset.hasOwnProperty( 'function' ) ? element.dataset.function : null;

	if ( modal == undefined ) {
		return;
	}

	// If element to open has class modal, add class overflow to body
	// Overflow class is used in css to apply overflow hidden on body
	// to prevent scrolling while modal is openned
	if ( modal.classList.contains( 'modal' ) || modal.classList.contains( 'navbar-collapse' ) ) {
		document.body.classList.remove( 'overflow' );
	}
	switch ( type_of_animation ) {
		case 'fade':
			$( modal ).fadeOut();
			break;
		case 'slide':
			$( modal ).slideUp();
			break;
		default:
			modal.classList.remove( elClass );
	}
}

/**
 * Toggles element with css class or jquery methods fadeIn and slideIn
 *
 * @param element {HTMLElement} HTML Element from Document
 * @param elClass {string}      Class to control, default is show
 */
function toggleElement( element, elClass = 'show' ) {
	element.setAttribute( 'aria-expanded', element.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );
	// Get element to open from btn's data-open attribute
	const modal             = document.querySelector( element.dataset.togle ),
	      type_of_animation = element.dataset.hasOwnProperty( 'function' ) ? element.dataset.function : null;

	if ( modal == undefined ) {
		return;
	}

	// If element to open has class modal, add class overflow to body
	// Overflow class is used in css to apply overflow hidden on body
	// to prevent scrolling while modal is openned
	if ( modal.classList.contains( 'modal' ) || modal.classList.contains( 'navbar__collapse' ) || modal.id == 'header' ) {
		document.body.classList.toggle( 'overflow' );
	}
	switch ( type_of_animation ) {
		case 'fade':
			$( modal ).fadeToggle();
			break;
		case 'slide':
			$( modal ).slideToggle();
			break;
		default:
			modal.classList.toggle( elClass );
	}
}

/**
 * Empty all inputs in form
 * @param form
 * @constructor
 */
function EmptyFormInputs( form ) {
	Array.from( form.elements ).forEach( el => {
		if ( el.type != 'hidden' ) {
			el.value = '';
		}
	} );
}

/**
 * Animate elements height to original
 * @param element
 * @param classCheck {string}
 * @constructor
 */
function HeightAnim( element, classCheck = 'show' ) {
	element.style.height = 'auto';
	const item_height    = element.classList.contains( classCheck ) ? element.offsetHeight : 0;
	element.style.height = '0px';
	setTimeout( () => {
		element.style.height = item_height + 'px';
	}, 50 );
}

/**
 *
 * @param carousel
 */
function initCarouselIndicators( carousel ) {
	const carousel_item_index = carousel.querySelector( '.carousel__indicator' ),
	      carousel_inner      = carousel.querySelector( '.carousel-inner' );
	if ( carousel_inner && carousel_item_index ) {
		$( carousel ).on( 'slid.bs.carousel', e => {
			const current_slide             = e.to + 1;
			carousel_item_index.textContent = current_slide + ` / ${ carousel_inner.childElementCount }`;
		} );
	}
}

/**
 * Custom collapse function. Closes all siblings when one is clicked and toggles clicked one if necessery
 * Layout for Collapse
 *
 <div id="accordion">
 <div class="collapsible">
 <button class="btn active" data-collapse="#collapseOne" data-parent="#accordion">Element 1</button>
 <div id="collapseOne" class="collapse show">

 </div>
 </div>
 <div class="collapsible">
 <button class="btn" data-collapse="#collapseTwo" data-parent="#accordion">Element 2</button>
 <div id="collapseTwo" class="collapse">

 </div>
 </div>
 </div>
 *
 */
function Collapsible() {
	document.addEventListener( 'click', e => {
		if ( !e.target.closest( '[data-collapse]' ) ) return;
		const closest_el        = e.target.closest( '[data-collapse]' ),
			parent_el         = document.querySelector( closest_el.dataset.parent ),
			current_target_el = parent_el.querySelector( closest_el.dataset.collapse ),
			btn_collapses     = parent_el.querySelectorAll( '[data-collapse]' );

		btn_collapses.forEach( btn => {
			const other_target_el = parent_el.querySelector( btn.dataset.collapse );

			// If it's the same btn than toggle elements class, otherwise remove class show
			if ( btn.classList === closest_el.classList ) {
				current_target_el.classList.toggle( 'show' );
				closest_el.classList.toggle( 'active' );
			} else {
				other_target_el.classList.remove( 'show' );
				btn.classList.remove( 'active' );
			}

			// Control every collapsible height
			new HeightAnim( other_target_el );
		} );

	} );
}

/**
 * Check if HTML Element has data attribute
 *
 * @param element
 * @param property - data attribute
 * @returns {boolean}
 */
function optc( element, property ) {
	return element.dataset.hasOwnProperty( property );
}

/**
 *
 * Controls anchor links in content for scrolling to element
 *
 * @param selector
 * @param correction
 * @constructor
 */
function AnchorScroll( selector, correction ) {
	if ( !selector ) {
		console.error( 'You must provide a selector!' );
		return;
	}

	document.addEventListener( 'click', e => {
		if ( !e.target.closest( selector ) ) return;
		e.preventDefault();

		const closest_el = e.target.closest( selector ),
		      target_el  = document.querySelector( closest_el.hash );

		if ( !target_el ) {
			return;
		}

		setTimeout( () => {
			window.scrollTo( {
				                 top:      target_el.getBoundingClientRect().top - correction,
				                 behavior: 'smooth'
			                 } );
		}, 50 );
	} );
}

/**
 *
 * @param form_elements
 * @returns {FormData}
 * @constructor
 */
function CreateFormData( form_elements ) {
	// Make form data object and populate it with all inputs from form
	const data = new FormData();
	form_elements.forEach( el => {
		if ( el.value !== '' ) {
			data.append( el.name, el.value );
		}
	} );

	return data;
}


/**
 * Create form data from form elements
 * @param form_elements
 * @returns {FormData}
 * @constructor
 */
function CreateFormDataFilter( form_elements ) {
	// Make form data object and populate it with all inputs from form
	let data = new FormData();
	Array.from(form_elements).forEach(el => {
		if (el.type === 'file') {
			data.append(el.name, el.files[0]);
		} else if (el.type === 'checkbox' && el.checked || el.type === 'radio' && el.checked) {
			data.append(el.name, el.value);
		} else if (el.value !== '' && el.type !== 'checkbox' && el.type !== 'radio') {
			data.append(el.name, el.value);
		}
	});

	return data;
}

function Emmit( element, { type, bubbles = true, cancelable = false } ) {
	const event = document.createEvent( 'HTMLEvents' ),
		el    = element === '' ? document : element instanceof Element ? element : document.querySelector( element );
	if ( !el ) {
		console.warn( 'Cannot find element', element );
		return;
	}
	event.initEvent( type, bubbles, cancelable );
	el.dispatchEvent( event );
}

/**
 * Scroll to top
 * Controls showing button and handles click event to scroll to top
 *
 */
class ToTop {
	/**
	 * @param btn {string, Element} - HTML button element
	 * @param amount_to_scroll {number} - amount to scroll in pixels
	 */
	constructor( btn, amount_to_scroll = 800 ) {
		this.btn              = btn instanceof Element ? btn : document.querySelector( btn );
		this.amount_to_scroll = amount_to_scroll;

		if ( !this.btn ) {
			console.warn( `Cannot find or invalid selector for btn: '${ btn }'` );
			return;
		}

		this.showToTop();
		this.attachClick();
	}

	/**
	 * Checks if document is scrolled enough to show btn
	 */
	showToTop() {
		window.pageYOffset > this.amount_to_scroll ? this.btn.classList.add( 'show' ) : this.btn.classList.remove( 'show' );

		requestAnimationFrame( () => {
			this.showToTop( this.btn, this.amount_to_scroll );
		} );
	}

	/**
	 * Attaches click event on button
	 */
	attachClick() {
		this.btn.addEventListener( 'click', this.scrollToTop );
	}

	scrollToTop() {
		window.scrollTo( {
			top:      0,
			behavior: 'smooth'
		} );
	}
}

export {
	showElement,
	HideElement,
	toggleElement,
	initCarouselIndicators,
	optc,
	Emmit,
	Collapsible,
	CreateFormData,
	CreateFormDataFilter,
	EmptyFormInputs,
	HeightAnim,
	AnchorScroll,
	ToTop
};



// WEBPACK FOOTER //
// ./scripts/modules/utils.js